import { useChatPlatform } from '../context/ChatPlatformContext';

/**
 * Hook to handle responsive states across the chat platform.
 * Consumes state from ChatPlatformContext to ensure consistency and performance.
 */
export function useResponsive() {
    const context = useChatPlatform();
    
    return {
        isMobile: context.isMobile,
    };
}
